module.exports = __webpack_public_path__ + "img/course_analy.06a91d99.svg";